// SectionDivider.js
import React from 'react';
import '../styles/SectionDivider.css';

function SectionDivider({ imageUrl, altText }) {
  return (
    <div className="section-divider-container">
      <div 
        className="section-divider"
        style={{ backgroundImage: `url(${imageUrl})` }}
        aria-label={altText}
      />
    </div>
  );
}

export default SectionDivider;
